'use client';

import { ScrollButtonProps } from './types';

import { Button } from '@/shared/components/button';
import smoothScroll from '@/shared/utils/smoothScroll';

export const ScrollButton = ({ target, ...buttonProps }: ScrollButtonProps) => (
  <Button
    onClick={() => smoothScroll(target)}
    {...buttonProps}
    ariaLabel="ScrollButton"
  />
);
